import { plugin, debug } from 'light-component';
import { useMemo, type ReactElement } from 'react';
import { Select } from 'antd';
import { t } from '../../i18n';
import styles from './style.module.less';
import type { SelectProps } from './types';

export function WidgetFormSelects(props: SelectProps): ReactElement {
  debug.widget('dashboard select', props);

  const options = useMemo(() => {
    const options = props.options?.map?.(item => ({
      value: item.value,
      label: item.title
    }));

    return options;
  }, [props.options]);

  return (
    <div className={props.className}>
      <Select
        className={styles.selectBox}
        disabled={props.readonly}
        title={t(props.title)}
        placeholder={props.placeholder}
        onChange={value => props.onChange?.(value)}
        value={props.value}
        options={options}
        filterOption={(input, options) => (options?.label ?? '').toLowerCase().includes(input.trim().toLowerCase())}
        showSearch
        allowClear
      />
    </div>
  );
}

plugin.register({ kind: 'widget', type: 'form-select', component: WidgetFormSelects });
